module.exports = __webpack_public_path__ + "c5291682eb33960150acef8f1ba3f8c1.svg";